import React from 'react';
import './styles.css';
import { Autocomplete, Calendar, TextField } from 'papaya-ui';
import { connect } from 'react-redux';
import _ from 'lodash';
import { WithTranslation, withTranslation } from 'react-i18next';
import ClaimService from '../../../../../config/ClaimWebsite/modelService';
import utils from '../../../../../config/utils';
import KEYS from '../../../../../config/key';

interface IProps extends WithTranslation{
  onChange: Function;
  dispatch: Function;
  onError?: Function;
  childValue?: BankType;
  onValid?: Function;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  error?: BankType;
  banksData: Array<{ name: string; value: string }>;
  citiesData: Array<{ name: string; value: string }>;
}

export interface BankType {
  bankCode?: string;
  bankBranch?: string;
  bankCity?: string;
  receiverName?: string;
  receiverId?: string;
  receiverIdLocation?: string;
  receiverIdDate?: Date;
  paymentType?: string;
}

interface IState {
  banks: Array<{ name: string; value: string }>;
  cities: Array<{ name: string; value: string }>;
  checkApi: boolean,
  checkReceiverName: boolean
}

const mapStateToProp = (state) => ({
  data: state.data,
});

class Bank extends React.Component<IProps, IState> {
  timeOut;

  constructor(props) {
    super(props);
    this.state = {
      banks: [],
      cities: [],
      checkApi: false,
      checkReceiverName: true
    };
  }

  componentDidMount = (): void => {
    this.getBankList().then();
    this.getCityList().then();
    this.handleLogicAll();
  };

  componentDidUpdate(prevProps: Readonly<IProps>, prevState:Readonly<IState>) {
    if(prevProps.error !== this.props.error) {
      this.handleLogicAll();
    }

    if(prevProps.childValue !== this.props.childValue) {
      this.handleLogicAll();
    }

    if(prevProps.banksData !== this.props.banksData) {
      this.getBankList();
    }

    if(prevProps.citiesData !== this.props.citiesData) {
      this.getCityList();
    }

    if(prevState.checkReceiverName !== this.state.checkReceiverName) {
      this.handleLogicAll();
    }
  }

  getBankList = async () => {
    const { banksData } = this.props;
    this.setState({
      banks: banksData
    });
  };

  getCityList = async () => {
    const { citiesData } = this.props;
    this.setState({
      cities: citiesData
    });
  };
  
  handleChange = (name, value) => {
    const { onChange, childValue, error, onError, onValid } = this.props;
    const newError = error || {};
    const newData = _.clone(childValue) || {};
    if (name === KEYS.FIELD.RECEIVER_NAME && onValid) {
      onValid(KEYS.PAYMENT_TYPE.BANK_MONEY.VALUE, false);
      newData[name] = value.toUpperCase();
    } else if (name === KEYS.FIELD.BANK_BRANCH) {
      newData[name] = value.toUpperCase();
    } else {
      newData[name] = value;
    }
    if(!value) {
      delete newData[name];
    }
    if((name === KEYS.FIELD.RECEIVER_ID) && value
      && (!utils.validate(KEYS.VALIDATE.PHONE, value))) {
      // wrong validate
    } else if((name === KEYS.FIELD.RECEIVER_NAME) && value
        && (!utils.validate(KEYS.VALIDATE.NAME, value))) {
      // wrong validate
    } else if (
      name === KEYS.FIELD.BANK_BRANCH &&
      value &&
      !utils.validate(KEYS.VALIDATE.BANK_BRANCH, value)
    ) {
      // wrong validate
    } else {
      if (onChange) {
        onChange('cash', newData);
      }
      if (onError) {
        onError('cash', newError);
      }
      this.handleValidate(name, newData[name]);
    }
  };
  
  handleValidate = async (name, value) => {
    const { t } = this.props;
    const { error, onError } = this.props;
    const newError = error || {};
    if(!value) {
      delete newError[name];
    }
    switch (name) {
      case KEYS.FIELD.BANKS_CODE: {
        if(!value) {
          newError[KEYS.FIELD.BANKS_CODE] = t('errors.INFO_INCORRECT');
        } else {
          delete newError[KEYS.FIELD.BANKS_CODE];
        }
        break;
      }
      
      case KEYS.FIELD.RECEIVER_ID: {
        if (value && (value.length !== 9 &&  value.length !== 12)) {
          newError[KEYS.FIELD.RECEIVER_ID] = t('errors.INFO_INCORRECT');
        } else {
          delete newError[KEYS.FIELD.RECEIVER_ID];
        }
        break;
      }
      case KEYS.FIELD.BANK_BRANCH: {
        if (value && value.length > 50) {
          newError[KEYS.FIELD.BANK_BRANCH] = t('errors.INFO_INCORRECT');
        } else {
          delete newError[KEYS.FIELD.BANK_BRANCH];
        }
        break;
      }
      case KEYS.FIELD.RECEIVER_ID_LOCATION: {
        if (value && value.length > 255) {
          newError.receiverIdLocation = t('errors.INFO_INCORRECT');
        } else {
          delete newError.receiverIdLocation;
        }
        break;
      }
      case KEYS.FIELD.RECEIVER_NAME: {
        this.setState({
          checkReceiverName: false
        }, () => {
          this.handleReceiverName(value);
        });
        break;
      }
    }
    if (onError) {
      onError('cash', newError);
    }
    return !!newError[name];
  };

  handleReceiverName = async (receiverName?:string) => {
    const { data, error, onError, t } = this.props;
    const newError = error || {};
    clearTimeout(this.timeOut);
    if(receiverName && receiverName.length > 4) {
      this.timeOut = setTimeout( async () => {
        const response = await ClaimService.verifyOwnerName(
          data.mainData && data.mainData[KEYS.FIELD.CLAIM_ID],
          utils.formatVnString(receiverName || '')
        );
        if (response && response.status) {
          if (response.status === 404) {
            newError[KEYS.FIELD.RECEIVER_NAME] = t('errors.WRONG_OWNER_NAME');
            if (onError) {
              onError('cash', newError);
            }
          }
        } else {
          delete newError[KEYS.FIELD.RECEIVER_NAME];
        }
        this.setState({
          checkApi: true
        }, async () => {
          await this.handleLogicAll();
        });
      }, 500);
    }
  };

  handleLogicAll = async () => {
    const { childValue, onValid, error } = this.props;
    const { checkApi, checkReceiverName } = this.state;
    if (onValid && childValue && error) {
      delete childValue.paymentType;
      if(childValue.receiverName
          && childValue.receiverName.length >= 4
          && checkApi && !error.receiverName) {
        this.setState({
          checkReceiverName: true
        });
      }


      if (Object.keys(childValue).length === 7
            && Object.keys(error).length === 0) {
        if(checkReceiverName) {
          onValid(KEYS.PAYMENT_TYPE.BANK_MONEY.VALUE, true);
        }
      } else {
        onValid(KEYS.PAYMENT_TYPE.BANK_MONEY.VALUE, false);
      }
      this.setState({
        checkApi: false
      });
    }
  };

  render() {
    const { childValue, error, t } = this.props;
    const { banks, cities }: Readonly<IState> = this.state;
    return (
      <div className="bankContainer">
        <div className="firstRowBank">
          <Autocomplete
            className="listBank"
            name="bankCode"
            label={t('payment.label.bankName')}
            placeHolder={t('payment.placeHolder.bankName')}
            options={banks}
            errorPosition="bottom"
            onChange={(name, value) => this.handleChange(name, value)}
            value={(childValue && childValue.bankCode) || ''}
          />
        </div>

        <div className="secondRowBank">
          <Autocomplete
            className="listCity"
            name="bankCity"
            label={t('payment.label.bankCity')}
            placeHolder={t('payment.placeHolder.bankCity')}
            options={cities}
            errorPosition="bottom"
            onChange={(name, value) => this.handleChange(name, value)}
            value={(childValue && childValue.bankCity) || ''}
          />

          <TextField
            className="branchBank"
            name={KEYS.FIELD.BANK_BRANCH}
            label={t('payment.label.bankBranch')}
            helperText={t('payment.helperText.bankBranch')}
            placeHolder={t('payment.placeHolder.bankBranch')}
            type="text"
            max={50}
            errorPosition="bottom"
            errorMsg={(error && error[KEYS.FIELD.BANK_BRANCH]) || ''}
            onChange={(name, value) => this.handleChange(name, value)}
            value={(childValue && childValue[KEYS.FIELD.BANK_BRANCH]) || ''}
          />
        </div>

        <div className="thirdRowBank">
          <TextField
            className="nameBank"
            name={KEYS.FIELD.RECEIVER_NAME}
            label={t('payment.label.receiverName')}
            helperText={t('payment.helperText.receiverName')}
            placeHolder={t('payment.placeHolder.receiverName')}
            type="text"
            errorPosition="bottom"
            errorMsg={(error && error[KEYS.FIELD.RECEIVER_NAME]) || ''}
            onChange={(name, value) => this.handleChange(name, value)}
            value={(childValue && childValue[KEYS.FIELD.RECEIVER_NAME]) || ''}
          />

          <TextField
            className="identityBank"
            name={KEYS.FIELD.RECEIVER_ID}
            label={t('payment.label.receiverNationalId')}
            placeHolder={t('payment.placeHolder.receiverNationalId')}
            type="text"
            errorPosition="bottom"
            errorMsg={(error && error[KEYS.FIELD.RECEIVER_ID]) || ''}
            onChange={(name, value) => this.handleChange(name, value)}
            value={(childValue && childValue[KEYS.FIELD.RECEIVER_ID]) || ''}
          />
        </div>

        <div className="fourthRowBank">
          <Calendar
            className="dateIdentity"
            name={KEYS.FIELD.RECEIVER_ID_DATE}
            label={t('payment.label.receiverIDDate')}
            pastBack
            placeHolder={t('payment.placeHolder.receiverIDDate')}
            topShow={window.screen.height> 420}
            bottomShow={window.screen.height <= 420}
            onChange={(name, value) => this.handleChange(name, value)}
            value={childValue && childValue[KEYS.FIELD.RECEIVER_ID_DATE]}
          />
          <TextField
            className="placeReceiver"
            name={KEYS.FIELD.RECEIVER_ID_LOCATION}
            label={t('payment.label.receiverIDLocation')}
            placeHolder={t('payment.label.receiverIDLocation')}
            type="text"
            errorPosition="bottom"
            errorMsg={(error && error[KEYS.FIELD.RECEIVER_ID_LOCATION]) || ''}
            onChange={(name, value) => this.handleChange(name, value)}
            value={(childValue && childValue[KEYS.FIELD.RECEIVER_ID_LOCATION]) || ''}
          />
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProp)(withTranslation('common')(Bank));
